<style scoped>
.camera {
    max-width: 100%;
    max-height: 100%;
}

.qr-loader {
    position: absolute;
    width: 100%;
    height: 100%;

    background-color: rgba(53, 53, 53, 0.8);

    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
}

.qr-loader-label {
    max-width: 80%;
    height: 50px;
    background-color: white;
    flex: 0 1 auto;
    padding: 0px 10px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 20px -3px rgba(0, 0, 0, 0.51);
    box-shadow: 0px 0px 20px -3px rgba(0, 0, 0, 0.51);
}

.qr-loader-label-text {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(77, 133, 255);
}
</style>

<template>
    <div :style="{ height: setScrollBarHeight }" :class="{ 'd-none': detect }">
        <qrcode-stream :track="false" :camera="setCamera" class=".camera" @init="onInit" @decode="onDecode">
            <div v-if="showLoader" class="qr-loader">
                <v-layout justify-center align-center class="qr-loader-label">
                    <v-flex justify-center align-center style="height: 100%">
                        <div class="qr-loader-label-text" style="height: 100%; width: 100%">
                            {{ $t("lang.loading") }}
                            <v-progress-circular class="ml-2" indeterminate color="rgb(77, 133, 255)"></v-progress-circular>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
            <div v-else-if="show_rescan" class="qr-loader">
                <v-layout justify-center align-center class="qr-loader-label primary clickable">
                    <v-flex>
                        <div class="qr-loader-label-text white--text" style="height: 100%; width: 100%" @mouseup.left="toggleLoader()">
                            {{ $t("lang.rescan") }}
                            <v-icon class="material-icons-outlined">restart_alt</v-icon>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </qrcode-stream>
    </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
export default {
    props: ["start", "detect"],
    components: {
        QrcodeStream,
    },
    data() {
        return {
            camera: null,
            last_camera: null,
            result: null,
            showLoader: false,
            camera_timer: null,
            no_rear_camera: false,
            no_front_camera: false,
            tried_front_camera: false,
            tried_rear_camera: false,
            no_cams: false,
            show_rescan: false,
            default_camera: $cookies.get("bc-default-camera") || null,
        };
    },
    computed: {
        setCamera() {
            let cam = "off";
            // if testing or if both camera arent set to off
            if (this.detect || !($cookies.get("bc-rear-cam") == "0" && $cookies.get("bc-front-cam") == "0")) {
                if (this.camera == null && this.start) {
                    cam = this.start;
                } else {
                    cam = this.camera || this.default_camera || "rear";
                }
                if (!this.detect) {
                    if (cam == "rear" && $cookies.get("bc-rear-cam") == "0") {
                        cam = "front";
                    } else if (cam == "front" && $cookies.get("bc-front-cam") == "0") {
                        cam = "rear";
                    }
                }
            }
            return cam;
        },
        setScrollBarHeight() {
            if (this.$bp.smallScreen) {
                if (this.$bp.xs) {
                    return "calc(100vh - 120px)";
                } else {
                    return "calc(100vh - 124px)";
                }
            } else {
                return "500px";
            }
        },
        missingCamera() {
            return $cookies.get("bc-front-cam") == "0" || $cookies.get("bc-rear-cam") == "0";
        },
    },
    methods: {
        switchCamera() {
            clearTimeout(this.camera_timer);
            switch (this.setCamera) {
                case "front":
                    this.camera = "rear";
                    break;
                case "rear":
                    this.camera = "front";
                    break;
                case "auto":
                    this.camera = "front";
                    break;
            }
        },
        async onInit(promise) {
            // this.$store.commit('toggleModalLoader', true);
            this.showLoader = true;
            if (!this.detect && this.setCamera != "off") this.$emit("loader", true);

            this.tried_front_camera = this.setCamera == "front";
            this.tried_rear_camera = this.setCamera == "rear";
            try {
                await promise;
            } catch (error) {
                let cameraMissingError = error.name === "OverconstrainedError";
                // console.log('cameraMissingError', cameraMissingError)
                if (this.tried_rear_camera && cameraMissingError) {
                    this.no_rear_camera = true;
                    if (!this.detect && this.start != "front") {
                        this.switchCamera("front");
                    } else {
                        if (!this.detect && this.setCamera != "off") this.$emit("close");
                    }
                    // console.log('no_rear_camera', this.start, this.setCamera);
                }

                if (this.tried_front_camera && cameraMissingError) {
                    this.no_front_camera = true;
                    if (!this.detect && this.start != "rear") {
                        this.switchCamera("rear");
                    } else {
                        if (!this.detect && this.setCamera != "off") this.$emit("close");
                    }
                    // console.log('no_front_camera', this.start, this.setCamera);
                }
                if ((error || "").toString() == "NotFoundError: Requested device not found") {
                    if (!this.detect && this.setCamera != "off") this.$emit("no-cam");
                    this.no_cams = true;
                    this.no_front_camera = true;
                    this.no_rear_camera = true;
                    this.createAlert("error", "no_cameras");
                }
            } finally {
                if (this.result == null) {
                    this.showLoader = false;
                    if (!this.detect && this.setCamera != "off") this.$emit("loader", false);
                    if (this.setCamera != "off") {
                        if (this.tried_rear_camera || this.no_cams) {
                            $cookies.set("bc-rear-cam", this.no_rear_camera ? "0" : "1");
                        }
                        if (this.tried_front_camera || this.no_cams) {
                            $cookies.set("bc-front-cam", this.no_front_camera ? "0" : "1");
                        }
                        if (this.detect) {
                            this.pause();
                        } else {
                            this.camera_timer = setTimeout(() => {
                                this.last_camera = this.setCamera;
                                // this.camera_timer = null;
                                if (this.setCamera != "off") {
                                    this.$emit("timeout");
                                    this.$emit("loader", true);
                                    this.show_rescan = true;
                                    this.pause();
                                    this.createAlert("error", "scan_again");
                                }
                            }, 11000); // 11 seconds
                        }
                    }
                    if (this.detect) {
                        if (this.tried_rear_camera && this.no_rear_camera) this.createAlert("error", "no_rear_camera");
                        if (this.tried_front_camera && this.no_front_camera) this.createAlert("error", "no_front_camera");
                        this.$emit("done");
                    }
                }
                // this.showLoader = this.camera === "off"
                // this.$store.commit('toggleModalLoader', false);
            }
        },
        async onDecode(content) {
            if (content.length > 0) {
                this.result = content;
                this.last_camera = this.setCamera;
                this.pause();
                this.$emit("scanned", this.result);
            }
        },
        unpause() {
            this.camera = "auto";
        },
        pause() {
            this.camera = "off";
            clearTimeout(this.camera_timer);
        },
        toggleLoader(value) {
            this.show_rescan = false;
            this.showLoader = value ? value : !this.showLoader;
            if (!value) {
                this.result = null;
                this.camera = this.last_camera ? this.last_camera : this.start ? this.start : "auto";
            }
        },
    },
};
</script>
